import { StyleSheet } from '@react-pdf/renderer';

const parentStyles = StyleSheet.create({
  viewContainer: {
    marginBottom: 27
  },
  title: {
    minHeight: 24,
    paddingVertical: 2,
    paddingHorizontal: 4,
    justifyContent: 'center',
    backgroundColor: '#DFE2E7',
    fontFamily: 'Noto Sans',
    fontSize: 12,
    fontWeight: 400
  },
  titleText: {
    fontFamily: 'Noto Sans',
    fontSize: 12,
    fontWeight: 400,
    color: '#14151C'
  }
});

export default parentStyles;
